var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row my-children-2" },
    [
      _vm._t("top"),
      _vm._v(" "),
      _vm._l(_vm.group.konfigurationsmoeglichkeiten, function (configoption) {
        return [
          configoption.configtype === "Sorten"
            ? _c("SortenInput", { attrs: { option: configoption } })
            : _vm._e(),
          _vm._v(" "),
          configoption.configtype === "Dropdown"
            ? _c("OptionDropdown", {
                key: configoption.id,
                attrs: {
                  option: configoption,
                  baseWidth: _vm.baseWidth,
                  doubleWidthAllowed: _vm.doubleWidthAllowed,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change", [configoption.id, $event])
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          configoption.configtype === "Readonly"
            ? _c("OptionReadonly", {
                key: configoption.id,
                attrs: {
                  option: configoption,
                  baseWidth: _vm.baseWidth,
                  doubleWidthAllowed: _vm.doubleWidthAllowed,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          configoption.configtype === "Quantity"
            ? _c("OptionQuantity", {
                key: configoption.id,
                attrs: { option: configoption, baseWidth: _vm.baseWidth },
              })
            : _vm._e(),
          _vm._v(" "),
          configoption.configtype === "Auflage"
            ? _c("OptionAuflage", {
                key: configoption.id,
                attrs: { option: configoption },
              })
            : _vm._e(),
          _vm._v(" "),
          configoption.configtype === _vm.CONFIGOPTION_TYPE_PRODUCTION
            ? _c("OptionProduction", {
                key: configoption.id,
                attrs: { option: configoption },
              })
            : _vm._e(),
          _vm._v(" "),
          configoption.configtype === _vm.CONFIGOPTION_TYPE_FREIFORMAT
            ? _c("OptionFreeFormat", {
                key: configoption.id,
                attrs: { option: configoption },
              })
            : _vm._e(),
          _vm._v(" "),
          configoption.configtype === _vm.CONFIGOPTION_TYPE_LIEFERART &&
          !_vm.configuratorService.hasConfigoptionType(
            _vm.CONFIGOPTION_TYPE_PRODUCTION
          )
            ? _c("OptionLieferart", {
                key: configoption.id,
                attrs: { option: configoption },
              })
            : _vm._e(),
          _vm._v(" "),
          configoption.configtype ===
          _vm.CONFIGOPTION_TYPE_VORLAGENPRODUKTDESIGN
            ? _c("OptionVorlagenproduktdesign", {
                key: configoption.id,
                attrs: { option: configoption },
              })
            : _vm._e(),
          _vm._v(" "),
          configoption.configtype === "Druckdatei Upload"
            ? _c("OptionPrintfileUpload", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: configoption.customValues.showUploadFile,
                    expression: "configoption.customValues.showUploadFile",
                  },
                ],
                key: configoption.id,
                attrs: { option: configoption, fileuploadid: configoption.id },
              })
            : _vm._e(),
          _vm._v(" "),
          configoption.configtype === _vm.printqService.TYPE
            ? _c("PrintQUpload", { key: configoption.id })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }